import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { FollowUp } from '../../../domain/follow-up';
import { FollowUpStoreService } from '../../../services/stores/follow-up-store.service';
import { Router } from '@angular/router';
import { Property } from '../../../domain/property';
import { PropertyStoreService } from '../../../services/stores/property-store.service';
import { LoadingOverlayStoreService } from '../../../services/stores/loading-overlay-store.service';
import { LoadingState } from '../../../domain/loading-state';
import { TaskUtils } from '../../../util/task-utils';
import { WorkflowType } from '../../../domain/enums/workflow-type';
import { PhobosTaskInstanceService } from '../../../services/phobos-task-instance.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DatePropertyTimezonePipe } from '../../../pipes/date-property-timezone.pipe';

@Component({
   selector: 'app-my-follow-ups',
   standalone: true,
   imports: [
      CommonModule,
      TableModule,
      ProgressSpinnerModule,
      ButtonModule,
      CheckboxModule,
      ToastModule,
      DatePropertyTimezonePipe
   ],
   templateUrl: './my-follow-ups.component.html',
   styleUrls: ['./my-follow-ups.component.scss']
})
export class MyFollowUpsComponent implements OnInit {
   followUps: FollowUp[] = [];
   selectedFollowUps: FollowUp[] = [];
   isLoading: boolean = false;
   isCompleting: boolean = false;
   private selectedProperty: Property | undefined;

   constructor(
      private followUpStore: FollowUpStoreService,
      private propStore: PropertyStoreService,
      private loadingOverlayStore: LoadingOverlayStoreService,
      private router: Router,
      private formTaskService: PhobosTaskInstanceService,
      private messageService: MessageService
   ) {
      this.propStore.currentProperty.subscribe((value) => {
         this.selectedProperty = value;
      });
   }

   ngOnInit(): void {
      this.isLoading = true;
      this.followUpStore.followUps.subscribe((f) => {
         this.followUps = f;
         this.isLoading = false;
         this.isCompleting = false;
      });
   }

   completeSelectedFollowUps(): void {
      const idArray: number[] = [];
      const formIdArray: number[] = [];

      for (const item of this.selectedFollowUps) {
         if (item.type === WorkflowType.Form) {
            formIdArray.push(item.id);
         } else {
            idArray.push(item.id);
         }
      }

      const loadingState = new LoadingState();
      loadingState.FollowUps = true;
      this.isCompleting = true;
      this.loadingOverlayStore.setLoadingState(loadingState);

      if (idArray.length > 0) {
         this.followUpStore.completeFollowUps(idArray).subscribe({
            next: (result) => {
               if (result > 0) {
                  this.followUpStore.refreshStore();
                  this.messageService.add({
                     severity: 'success',
                     summary: 'Follow Ups Completed',
                     detail: `${idArray.length} follow-up(s) marked as completed`
                  });
               }
               this.isCompleting = false;
            },
            error: () => {
               this.messageService.add({
                  severity: 'error',
                  summary: 'Error Completing Follow Ups',
                  detail: 'An error occurred while completing standard follow-ups.'
               });
               this.isCompleting = false;
            }
         });
      }

      if (formIdArray.length > 0) {
         this.formTaskService.completeFollowUps(formIdArray).subscribe({
            next: (r) => {
               if (r > 0) {
                  this.followUpStore.refreshStore();
                  this.messageService.add({
                     severity: 'success',
                     summary: 'Follow Ups Completed',
                     detail: `${formIdArray.length} follow-up(s) marked as completed`
                  });
                  this.isCompleting = false;
               }
            },
            error: () => {
               this.messageService.add({
                  severity: 'error',
                  summary: 'Error Completing Form Follow Ups',
                  detail: 'An error occurred while completing form follow-ups.'
               });
               this.isCompleting = false;
            }
         });
      }
   }

   async goToTask(formData: FollowUp, $event: MouseEvent) {
      if (this.selectedProperty) {
         $event.preventDefault();
         await TaskUtils.goToForm(formData, this.router, this.selectedProperty);
      }
   }
}
